import { useEffect, useState } from 'react';
import { useStyleId } from '../../app/store';
import { styleEntry, styleName } from '../../data/styles';
import { previewProjectName } from '../../db/repos/projects';
import { BottomSheet } from '../../ui/BottomSheet';
import { Button } from '../../ui/Button';
import { Row, RowList } from '../../ui/Row';
import styles from './Beat.module.css';

/** New project (SPEC F7): the current style's BPM, a name made for you, and a kit suggested from your library. Start is the one action. */
export function NewProjectSheet({ open, hasSamples, onStart, onClose }: {
  open: boolean;
  hasSamples: boolean | undefined;
  onStart: () => Promise<void>;
  onClose: () => void;
}) {
  const styleId = useStyleId();
  const [preview, setPreview] = useState<{ styleId: string; name: string }>();
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    if (!open) return;
    void previewProjectName(styleId).then((name) => setPreview({ styleId, name }), () => undefined);
  }, [open, styleId]);

  const name = preview?.styleId === styleId ? preview.name : undefined;

  const start = async () => {
    setStarting(true);
    try {
      await onStart();
    } finally {
      setStarting(false);
    }
  };

  return (
    <BottomSheet open={open} title="New project" onClose={onClose}>
      <div className={styles.sheetBody}>
        <RowList label="New project">
          <li><Row title={name ?? styleName(styleId)} meta="Name, you can rename it later" /></li>
          <li><Row title={styleName(styleId)} meta="Style, change it in the header" /></li>
          <li><Row title={`${styleEntry(styleId)?.bpmDefault ?? 90} BPM`} meta="Tempo, from the style" /></li>
          <li>
            <Row
              title={hasSamples ? 'Kit suggested' : 'No kit yet'}
              meta={hasSamples ? 'Picked from your drum library' : 'Import drums in Drums, then suggest a kit'}
            />
          </li>
        </RowList>
        <div className={styles.sheetActions}>
          <Button variant="primary" full large loading={starting} loadingLabel="Starting" onClick={() => void start()}>Start</Button>
        </div>
      </div>
    </BottomSheet>
  );
}
